import React from 'react';
import PropTypes from 'prop-types';

const SofaBedNot = ({ color = '#BCC6CA', lineColor = '#fff', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill={color}
      d="M21.84 15.04c0-.4-.16-.8-.48-1.12a1.58 1.58 0 0 0-1.12-.48h-.16v-.16c0-.96-.4-1.92-1.04-2.56-.72-.72-1.6-1.04-2.56-1.04h-9.2c-.96 0-1.92.4-2.56 1.04-.72.72-1.04 1.6-1.04 2.56v.16h-.16c-.88 0-1.52.72-1.52 1.52v3.36c0 .96.72 1.84 1.68 1.92v1.44c0 .16.16.32.32.32s.32-.16.32-.32v-1.36H19.6v1.36c0 .16.16.32.32.32s.32-.16.32-.32v-1.44c.96-.16 1.68-.96 1.68-1.92l-.08-3.28Zm-5.28-4.72c.8 0 1.6.32 2.16.88s.88 1.36.88 2.16v.32c-.48.24-.8.8-.8 1.36v.8c0 .32-.24.56-.56.56h-6.4v-6.08h4.72ZM4.24 13.36c0-.8.32-1.6.88-2.16a3.09 3.09 0 0 1 2.16-.88h3.92v6.08H5.6c-.32 0-.56-.24-.56-.56v-.8c0-.56-.32-1.12-.8-1.36v-.32Zm17.04 4.96c0 .8-.64 1.36-1.36 1.36H4c-.8 0-1.36-.64-1.36-1.36v-3.36c0-.56.4-.96.96-.96.56 0 .96.4.96.96v.8c0 .64.48 1.12 1.12 1.12h12.56c.64 0 1.12-.48 1.12-1.12v-.8c0-.56.4-.96.96-.96.24 0 .48.08.64.32.16.16.32.4.32.64v3.36Z"
    />
    <path
      fill={color}
      fillRule="evenodd"
      d="M13.28 8.56v.4h-2.24v-.32l1.6-2.08h-1.52v-.4h2.08v.32l-1.6 2.08h1.68Zm4.08-.88v.56H14.4v-.4l2.16-2.88h-2.08V4.4h2.88v.4L15.2 7.68h2.16Zm4.32-1.76v.64h-3.6v-.48l2.56-3.44h-2.48V2h3.44v.48l-2.56 3.44h2.64Z"
      clipRule="evenodd"
    />
    <rect
      width={1.5}
      height={28.638}
      x={1.354}
      y={2.414}
      fill={color}
      stroke={lineColor}
      strokeWidth={0.5}
      rx={0.75}
      transform="rotate(-45 1.354 2.414)"
    />
  </svg>
);

SofaBedNot.propTypes = {
  color: PropTypes.string,
  lineColor: PropTypes.string
};

export default SofaBedNot;
